@use "~theme/typographyV2" as typography;
@use "~theme/breakpoints";
@use "~components/LegacyCard/tokens.scss" as Card;


.container {
  display: none;

  @include breakpoints.desktop {
    display: block;
  }  
}

.firstContainer {
  display: block;
  overflow: auto;
  border-bottom: 1px solid var(--gray-06);
}

.stickySection {
  position: relative;
}

.rightContainer {
  width: 30%;
  float: left;
  margin-left: 25px;
  right: 1%;
}

.stickyContainer {
  z-index: 1;
  position: absolute;
  top: var(--sticky-top-offset, 10px);
}

.howCanWeHelpYou {
  @include typography.heading3;

  @include breakpoints.desktop {
    text-align: center;
  }
}

.getStarted {
  width: 100%;
}

.card {
  @include breakpoints.desktop {
    max-width: Card.$max-width;
    margin-left: auto;
    margin-right: auto;
    margin-top: 36px;
  }
}

.scheduleContainer {
  padding: 20px;

  @include breakpoints.desktop {
    padding: 28px;
  }
}

.scheduleMyExam {
  @include typography.heading4;
  text-align: center;
  padding-bottom: 20px;

  @include breakpoints.desktop {
    padding-bottom: 36px;
  }
}

.preamble {
  padding: 20px 20px 0;

  @include breakpoints.desktop {
    padding-top: 40px;
  }
}

.introduction {
  padding-top: 20px;
  letter-spacing: 0.02em;

  @include breakpoints.desktop {
    text-align: center;
    padding-top: 28px;
  }
}

.logoContainer {
  text-align: center;
  padding-top: 4px;
  padding-bottom: 24px;

  @include breakpoints.desktop {
    padding-bottom: 36px;
  }
}

.backToHome {
  display: none;
  order: 2;
  flex-grow: 0;
  padding: 0 32px;

  &:hover:not(.buttonLoading) {
    border-color: var(--blue-01);
  }

  @include breakpoints.desktop {
    display: block;
    align-self: center;
    margin-left: auto;
  }
}

.footerNextBtn {
  margin: 0px 0px 30px 0px;
  position: relative;
  z-index: 1;
  width: 230px;
  height: 40px;
  gap: 8px;
  opacity: 1;
  border-radius: 100px;
  padding: 12px 20px;
  background: var(--blue-01);
  color: var(--white);
  font-family: typography.$font-mont;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: none;
}

.footerNextBtnCustom {
  position: relative;
  z-index: 1;
  width: 230px;
  height: 40px;
  gap: 8px;
  opacity: 1;
  border-radius: 100px;
  background-color: var(--blue-01);
  color: var(--white);
  font-family: typography.$font-mont;
  font-weight: 600;
  font-style: normal;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0;
  vertical-align: middle;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-transform: none;

  span {
    display: inline-block;
    margin: 0;
    line-height: 1;
    font-family: typography.$font-mont;
    font-weight: 600;
    font-size: 16px;
    margin: 10px;
  }
}

.nearByModalOfficeBox {
  background-color: var(--white);
  padding: 8px;
  display: flex;
  width: 100%;
  border-radius: 4px;
  border-bottom: 1px solid var(--gray-02);

  &:last-child {
    border-bottom: none;
  }
}

.nearByModalOfficeBox:hover {
  cursor: pointer;
}

.selectedNearByModalOfficeBox {
  background-color: var(--blue-03);
  border-radius: 4px;
  padding: 8px 16px 8px 12px;
  display: flex;
  color: var(--blue-01);
  width: 100%;
}

.selectedNearByModalOfficeBox:hover {
  cursor: pointer;
}

.officeTitle {
  font-weight: var(--semibold-weight);
}

.continueBtn {
  margin-top: 4px;
  width: 100%;
}

.nonSelectedNearByModalOfficeBox {
  padding: 8px 16px 8px 12px;
  display: flex;
  width: 100%;
}

.modal {
  padding: 12px 8px 8px;
  background-color: var(--gray-04);
}

.modalOverlayCustom {
  opacity: 1;
  transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 0.8) 0ms;
  touch-action: none;
}

.prompt {
  margin: 0 8px;
}

.correctSign {
  left: 40px;
  min-width: 25px;
}

.officeContent {
  padding-left: 12px;
}

.contentWrap {
  overflow: auto;
  max-height: 355px;
  min-height: 150px;
  margin: 16px 0 12px;
  border-radius: 8px;
  box-shadow: 0 2px 6px var(--gray-03);
}

.checkmarkUnderline {
  border: 1px solid var(--blue-01-at-30);
  width: 18px;
  margin-top: 1px;
}

.correctSignSpace {
  height: 20px;
}

.saparatorLine {
  @include breakpoints.desktop {
    border-bottom: 1px solid var(--gray-06);
  }
}


.vehModal {
  width:500px;
  max-width: 500px;

  .dismissButton {
    display: none;
    width: 50px;
  }

  input {
    margin-right: 5px;
  }
  
  .vehTerms {
    font-size: 13px;
    line-height: 15px;
    margin-top: 15px;
  }

  .interrogative {
    @include typography.body-semibold;
    text-align: center;
    padding-bottom: 20px;
    margin: 0;
  }

  .qualifier {
    text-align: center;
    padding-bottom: 20px;
    margin: 0;
  }

  .button {
    flex: 1;
    margin: 0 8px;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }

  }

  .buttonRestrict {
    width: 100%;
    margin: 5px 0px;
    font-size: 14px;
  }

  .buttons {
    display: flex;
    flex-direction: row;
    margin-top: 25px;
  }
}

.buttonWrapper {

  .container {
    position: relative;
    display: inline-block;
  }
  
  .tooltipContainer {
    background-color: var(--blue-02);
    color: var(--white);
    border-radius: 4px;
    visibility: hidden;
    position: absolute;
    z-index: var(--float);
    width: 300px;
    padding: 4px 8px;
  }
  
  .tooltipContainer p {
    @include typography.body;
    margin-top: 0;
  }
  
  .tooltipContainer p:last-child {
    margin-bottom: 0;
  }
  
  .tooltipPositionTop {
    bottom: 100%;
    right: 0;
    left: auto;
    margin-left: 0;
    margin-bottom: 8px;
  }
  
  .tooltipPositionTop::after {
    content: " ";
    position: absolute;
    top: 100%; /* At the bottom of the tooltip */
    right: 100px;
    left: auto;
    margin-left: 0;
    border-width: 8px;
    border-style: solid;
    border-color: var(--blue-02) transparent transparent transparent;
  }
  
  .tooltipVisible {
    visibility: visible;
  }
  
  .content {
    padding: 12px;
  }
  
  .contentContainer {
    display: flex;
    flex-direction: row;
  }
  
  .buttonIcon {
    border: none;
    outline: none;
    padding: 0;
    font: inherit;
    color: inherit;
    background-color: transparent;
    cursor: pointer;
  }
}

.classRed {
  color: white;
  padding-top: 5px;
  font-family: typography.$font-mont;
}

.classWhite {
  color: white;
  padding-top: 5px;
  font-family: typography.$font-mont;
}

.iconCircle {
  width: 24px;
  height: 24px;
}

.restrictVEHContent {
  margin-bottom: 10px;
}

.modalReview {
  top: 0;
  left: 0;
  right: auto;
  bottom: auto;
  padding:0px;
  max-width: 100%;
  max-height:100%;
;
  @include breakpoints.desktop {
    top: 0;
    left: 0;
    right: auto;
    bottom: auto;   
    max-width: 903px;
    max-height: 569px;
    padding: 28px 0px 0px 0px;
  }

.reviewModal {
    padding: 0px;
    @include breakpoints.desktop {
    padding: 0px 50px;
    }

}

.closeIcon {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 10px;
  right: 10px;
}

}


.newvehModal {
    padding: 0px 20px 20px 20px;
    margin: 0px;
    width: 500px;
    max-width: 500px;
    height: 98%;

     @include breakpoints.desktop-medium {
      max-height: auto;
      height: auto;
    }
 
    @include breakpoints.desktop-large {
      max-height: auto;
      height: auto;
    }

    @media (min-width: 1100px) and (max-width: 1360px) {
      height: 98%;
      max-height: 98%;
      padding: 0px 20px;
    }

  .conClass {
    height: 98%;

    @media (min-width: 1100px) and (max-width: 1360px) {
      height: 100%;
      max-height: 100%;    
    }
  }

  .nvehheader {
    font-family: typography.$font-mont;
    font-weight: 600;
    font-style: Semibold;
    font-size: 26px;
    leading-trim: NONE;
    line-height: 120%;
    letter-spacing: 0%;
    vertical-align: middle;
    color: var(--black);
    margin: 0px 0px 5px 0px;
    white-space: nowrap;
  }

  .imgPatient {
  width: 100%;
  height: auto;
  display: block;

  @media (min-width: 1310px) and (max-width: 1360px) {
    height: 190px !important;
    max-height: 190px !important;
    object-fit: cover;
    object-position: center;    
  }

  /* default desktop view */
  @include breakpoints.desktop {
    height: 200px;
    max-height: 200px;
    object-fit: cover;
    object-position: center;
  }

  /* medium desktops (reset if needed) */
  @include breakpoints.desktop-medium {
    height: auto;
    max-height: none;
    object-fit: cover;
    object-position: center;
  }

  /* large desktops (reset if needed) */
  @include breakpoints.desktop-large {
    height: auto;
    max-height: none;
    object-fit: cover;
    object-position: center;
  }

  /* short viewports — reduce height to prevent scroll */
  @media (max-height: 760px) {
    height: 130px; /* 👈 tweak this number smaller/larger to fit your viewport */
    object-fit: cover;
    object-position: center;
  }

  /* ultra-short screens — further reduce if still overflowing */
  @media (max-height: 600px) {
    height: 110px;
    object-fit: cover;
    object-position: center;
  }

  @media (max-width: 360px) and (max-height: 900px) {
  height: 170px; /* 20px smaller than default */
  object-fit: cover;
  object-position: center;

  /* remove modal bottom padding if the image sits inside it */
  .newvehModal {
    padding-bottom: 0;
  }
 }
}
  

  // .imgPatient {
  //   width: 100%; /* Makes the image take up 100% of its parent's width */
  //   height: auto;
  //   @include breakpoints.desktop {
  //     max-height: 100px;
  //     height: 200px;
  //     object-fit: cover;
  //   }

  //   @include breakpoints.desktop-medium {
  //     max-height: auto;
  //     height: auto;
  //   }

  //   @include breakpoints.desktop-large {
  //     max-height: auto;
  //     height: auto;
  //   }
  // }

  .newP1 {
    font-family: typography.$font-mont;
    font-weight: 600;
    font-size: 16px;
    line-height: 140%;
    letter-spacing: 0%;
    vertical-align: middle;

    span {
      font-family: typography.$font-mont;
      font-weight: 400;
      font-style: Regular;
      font-size: 16px;
      leading-trim: NONE;
      line-height: 140%;
      letter-spacing: 0%;
      vertical-align: middle;

    }
  }
  .newL1 {
    font-family: typography.$font-mont;
    font-weight: 400;
    font-style: Regular;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 130%;
    letter-spacing: 0%;
    vertical-align: middle;
  }

  .listContainer {
    display: block;
    overflow: auto;
    padding-bottom: 10px;
  }

  .listImg {
    width: 5%;
    float: left;
  }

  .listText {
    width: 95%;
    float: left;
  }

  .newL2 {
    font-family: typography.$font-mont;
    font-weight: 400;
    font-style: Regular;
    font-size: 14px;
    line-height: 130%;
    letter-spacing: 0%;
    vertical-align: middle;

    ul {
      list-style: none;
      padding: 0px;
    }

  }

  .buttonAcc {
    width: 230px;
    height: 40px;
    font-family: typography.$font-mont;
    font-weight: 600;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0;
    text-align: center;
    text-transform: none;
    color: var(--white);
    background: var(--blue-01);
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 16px auto 5px;

  }

  .btnGoContainer {
    text-align: center;
  }

  .iconBack {

  }

  .buttonGo {
    font-family: typography.$font-mont;
    font-weight: 400;
    font-size: 16px;
    line-height: 130%;
    letter-spacing: 0%;
    vertical-align: middle;
    padding: 15px 0px;
    cursor: pointer;

  }
}
